/** @format */

import { Button, Checkbox, CircularProgress, Grid, Tooltip, Typography } from '@material-ui/core';
import SettingsCard from 'components/PhotoAdminComponents/Settings/Card/SettingsCard';
import React, { useEffect, useRef, useState } from 'react';
import TextField from '@material-ui/core/TextField';
import InfoIcon from '@mui/icons-material/Info';
import { Form, Formik } from 'formik';
import styles from './InvoiceVendorForm.module.css';
import validationSchema from 'validation/InvoiceVendor/Schema';
import { useSelector } from 'react-redux';
import PostalCodeFields from '../PostalCodeFields/PostalCodeFields';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import OutlinedInput from '@mui/material/OutlinedInput';
import { MenuItem } from '@mui/material';
import { useTranslation } from 'react-i18next';
const InvoiceVendorForm = ({ handleSave, invoiceVendor, user, loading, setOpen }) => {
  const formikRef = useRef(null);
  const shopId = useSelector((state) => state.nonPersistedReducers?.shopSliceReducer?.shopId);
  const { t } = useTranslation();

  const [isChecked, setIsChecked] = useState(false);
  const [showAPI, setShowAPI] = React.useState(false);
  const [showUser, setShowUser] = React.useState(false);

  const [vendorData, setVendorData] = useState({
    city: '',
    zipcode: ''
  });

  useEffect(() => {
    if (invoiceVendor) {
      setVendorData({
        city: invoiceVendor?.businessContact?.address?.city,
        zipcode: invoiceVendor?.businessContact?.address?.zipcode
      });
    }
  }, [invoiceVendor, formikRef]);

  useEffect(() => {
    formikRef.current.values.city = vendorData?.city;
    formikRef.current.values.zipcode = vendorData?.zipcode;
  }, [vendorData, formikRef]);

  useEffect(() => {
    if (isChecked && user) {
      setVendorData({
        city: user?.billingInfo?.billingAddress?.city,
        zipcode: user?.billingInfo?.billingAddress?.zipCode
      });

      formikRef.current.values.street = user?.billingInfo?.billingAddress?.streetAndNumber;
      formikRef.current.values.streetNo = '';
      formikRef.current.values.vatNumber = user?.billingInfo?.vatNumber;
    } else {
      formikRef.current.values.street = invoiceVendor ? invoiceVendor?.businessContact?.address?.street : '';
      formikRef.current.values.streetNo = invoiceVendor ? invoiceVendor?.businessContact?.address?.streetNo : '';
      formikRef.current.values.vatNumber = invoiceVendor ? invoiceVendor?.businessContact?.vatNumber : '';
      setVendorData({
        city: invoiceVendor ? invoiceVendor?.businessContact?.address?.city : '',
        zipcode: invoiceVendor ? invoiceVendor?.businessContact?.address?.zipcode : ''
      });
    }
  }, [isChecked, user, invoiceVendor, formikRef]);

  return (
    <SettingsCard>
      <Formik
        innerRef={formikRef}
        initialValues={{
          id: invoiceVendor?.id || '',
          name: invoiceVendor?.name || '',
          isActive: invoiceVendor?.isActive || false,
          // statusUrl: invoiceVendor?.statusUrl || "https://szamlazz.hu",
          vendorType: invoiceVendor?.vendorType || 'SZAMLAZZ_HU',
          vat: invoiceVendor?.vat || '0',
          shopId: invoiceVendor?.shopId || shopId,
          companyName: invoiceVendor?.businessContact?.companyName || '',
          vatNumber: invoiceVendor?.businessContact?.vatNumber || '',
          country: 'Magyarország',
          city: invoiceVendor?.businessContact?.address?.city || '',
          zipcode: invoiceVendor?.businessContact?.address?.zipcode || '',
          street: invoiceVendor?.businessContact?.address?.street || '',
          streetNo: invoiceVendor?.businessContact?.address?.streetNo || '',
          bankName: invoiceVendor?.businessContact?.bankAccount?.bankName || '',
          accountNumber: invoiceVendor?.businessContact?.bankAccount?.accountNumber || '',
          iban: invoiceVendor?.businessContact?.bankAccount?.iban || '',
          type: 'client',
          clientId: invoiceVendor ? invoiceVendor?.credentials?.clientId : '',
          clientSecret: invoiceVendor ? invoiceVendor?.credentials?.clientSecret : '',
          invoices: invoiceVendor?.invoices || []
        }}
        validate={false}
        validationSchema={validationSchema(t)}
        onSubmit={(values, { setSubmitting, resetForm }) => {
          setSubmitting(true);
          handleSave({
            body: {
              id: values.id,
              name: values.name,
              isActive: values.isActive,
              statusUrl: values.statusUrl,
              vendorType: values.vendorType,
              vat: values.vat,
              shopId: values.shopId || shopId,
              businessContact: {
                companyName: values.companyName,
                vatNumber: values.vatNumber,
                address: {
                  country: values.country,
                  city: values.city,
                  zipcode: values.zipcode,
                  street: values.street,
                  streetNo: values.streetNo
                },
                bankAccount: {
                  bankName: values.bankName,
                  accountNumber: values.accountNumber,
                  iban: values.iban
                }
              },
              credentials: {
                type: values.type,
                clientId: values.clientId,
                clientSecret: values.clientSecret
              },
              invoices: values.invoices
            },
            setOpen: setOpen
          });
          setSubmitting(false);
          resetForm();
        }}>
        {({ values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting, resetForm }) => (
          <Form className={styles.form}>
            <h1 className={styles.cardTitle}>
              {invoiceVendor ? invoiceVendor?.name : t('invoicing.invoiceVendorForm.new')}
              {/* {disabled && (
                <p className={styles.disabledMessage}>
                  Demo bolt esetén a számlakibocsátó szolgáltatás módosítása nem lehetséges!
                </p>
              )} */}
            </h1>
            <Grid container spacing={2} alignContent='center'>
              <Grid item xs={12}>
                <Typography
                  style={{
                    fontWeight: 'bold',
                    fontSize: '1.2rem'
                  }}>
                  {t('invoicing.invoiceVendorForm.integrationData')}
                </Typography>
              </Grid>
              <Grid container item xs={12} md={6}>
                <Grid item xs={12}>
                  <Typography color='primary' variant='body1'>
                    {t('invoicing.invoiceVendorForm.integrationName')}
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    disabled={loading}
                    variant='outlined'
                    margin='normal'
                    fullWidth
                    required
                    id='name'
                    name='name'
                    value={values.name}
                    onChange={(e) => {
                      handleChange(e);
                      setVendorData({
                        ...vendorData,
                        name: e.target.value
                      });
                    }}
                    error={Boolean(errors.name)}
                    helperText={touched.name && errors.name}
                  />
                </Grid>
              </Grid>
              {/* <Grid container spacing={0} item xs={12} md={6}>
                <Grid item xs={12}>
                  <Typography color="primary" variant="body1">
                    Szolgáltatás státusz URL-je
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    disabled
                    variant="outlined"
                    margin="normal"
                    fullWidth
                    id="statusUrl"
                    name="statusUrl"
                    value={values.statusUrl}
                    onChange={(e) => {
                      handleChange(e);
                      setVendorData({
                        ...vendorData,
                        statusUrl: e.target.value,
                      });
                    }}
                    error={Boolean(errors.statusUrl)}
                    helperText={touched.statusUrl && errors.statusUrl}
                  />
                </Grid>
              </Grid> */}
              <Grid container item xs={12} md={6}>
                <Grid item xs={12}>
                  <Typography color='primary' variant='body1'>
                    {t('invoicing.invoiceVendorForm.type')}
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    disabled={loading}
                    variant='outlined'
                    margin='normal'
                    fullWidth
                    required
                    select
                    id='vendorType'
                    name='vendorType'
                    value={values.vendorType}
                    onChange={(e) => {
                      handleChange(e);
                      setVendorData({
                        ...vendorData,
                        vendorType: e.target.value
                      });
                    }}
                    error={Boolean(errors.vendorType)}
                    helperText={touched.vendorType && errors.vendorType}>
                    <MenuItem value={'SZAMLAZZ_HU'}>SZAMLAZZ_HU</MenuItem>
                    <MenuItem value={'BILLINGO'}>BILLINGO</MenuItem>
                  </TextField>
                </Grid>
              </Grid>
              <Grid container item xs={12} md={6}>
                <Grid item xs={12}>
                  <Tooltip
                    title={'Más néven Számla Agent kulcs. A számlázz.hu fiókjában a vezérlőpult alján találhatja meg!'}>
                    <Typography color='primary' variant='body1'>
                      {t('invoicing.invoiceVendorForm.apiKey')}
                      <InfoIcon
                        style={{
                          fontSize: '0.9rem',
                          opacity: '0.5',
                          marginLeft: '0.5rem'
                        }}
                      />
                    </Typography>
                  </Tooltip>
                </Grid>
                <Grid item xs={12}>
                  <OutlinedInput
                    disabled={loading}
                    type={showAPI ? 'text' : 'password'}
                    endAdornment={
                      <InputAdornment position='end'>
                        <IconButton
                          aria-label='toggle password visibility'
                          onClick={() => {
                            setShowAPI(!showAPI);
                          }}
                          edge='end'>
                          {showAPI ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    }
                    variant='outlined'
                    margin='normal'
                    fullWidth
                    required
                    id='clientSecret'
                    name='clientSecret'
                    value={values.clientSecret}
                    onChange={(e) => {
                      handleChange(e);
                      setVendorData({
                        ...vendorData,
                        clientSecret: e.target.value
                      });
                    }}
                    error={Boolean(errors.clientSecret)}
                    helperText={touched.clientSecret && errors.clientSecret}
                  />
                </Grid>
              </Grid>
              <Grid container item xs={12} md={6}>
                <Grid item xs={12}>
                  <Tooltip
                    title={
                      'A számla előtag arra szolgál, hogy megkönnyítse a számlázz.hu felületen a számlák megkülönböztetését. A számlázz.hu felületen is használt előtagot adja meg!'
                    }>
                    <Typography color='primary' variant='body1'>
                      {t('invoicing.invoiceVendorForm.prefix')}
                      <InfoIcon
                        style={{
                          fontSize: '0.9rem',
                          opacity: '0.5',
                          marginLeft: '0.5rem'
                        }}
                      />
                    </Typography>
                  </Tooltip>
                </Grid>
                <Grid item xs={12}>
                  <OutlinedInput
                    disabled={loading}
                    type={showUser ? 'text' : 'password'}
                    endAdornment={
                      <InputAdornment position='end'>
                        <IconButton
                          aria-label='toggle password visibility'
                          onClick={() => {
                            setShowUser(!showUser);
                          }}
                          edge='end'>
                          {showUser ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    }
                    variant='outlined'
                    margin='normal'
                    fullWidth
                    required
                    id='clientId'
                    name='clientId'
                    value={values.clientId}
                    onChange={(e) => {
                      handleChange(e);
                      setVendorData({
                        ...vendorData,
                        clientId: e.target.value
                      });
                    }}
                    error={Boolean(errors.clientId)}
                    helperText={touched.clientId && errors.clientId}
                  />
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <Typography
                  style={{
                    fontWeight: 'bold',
                    fontSize: '1.2rem'
                  }}>
                  {t('invoicing.invoiceVendorForm.datas')}
                </Typography>
              </Grid>{' '}
              {user && (
                <Grid style={{ margin: '1rem 0', width: '100%' }}>
                  <Checkbox
                    checked={isChecked}
                    color='primary'
                    onChange={() => {
                      setIsChecked(!isChecked);
                    }}
                  />
                  {t('invoicing.invoiceVendorForm.givePrevious')}
                </Grid>
              )}
              <PostalCodeFields
                isEditing={!loading}
                data={vendorData}
                setData={setVendorData}
                zipHelper={formikRef?.current?.touched?.zipcode}
                zipError={formikRef?.current?.errors?.zipcode}
                cityHelper={formikRef?.current?.touched?.city}
                citypError={formikRef?.current?.errors?.city}
              />
              <Grid container item xs={12} md={6}>
                <Grid item xs={12}>
                  <Typography color='primary' variant='body1'>
                    {t('invoicing.invoiceVendorForm.street')}
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    disabled={loading}
                    variant='outlined'
                    margin='normal'
                    fullWidth
                    required
                    id='street'
                    name='street'
                    value={values.street}
                    onChange={(e) => {
                      handleChange(e);
                      setVendorData({
                        ...vendorData,
                        street: e.target.value
                      });
                    }}
                    error={Boolean(errors.street)}
                    helperText={touched.street && errors.street}
                  />
                </Grid>
              </Grid>
              <Grid container item xs={12} md={6}>
                <Grid item xs={12}>
                  <Typography color='primary' variant='body1'>
                    {t('invoicing.invoiceVendorForm.streetNo')}
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    disabled={loading}
                    variant='outlined'
                    margin='normal'
                    fullWidth
                    required
                    id='streetNo'
                    name='streetNo'
                    value={values.streetNo}
                    onChange={(e) => {
                      handleChange(e);
                      setVendorData({
                        ...vendorData,
                        streetNo: e.target.value
                      });
                    }}
                    error={Boolean(errors.streetNo)}
                    helperText={touched.streetNo && errors.streetNo}
                  />
                </Grid>
              </Grid>
              <Grid container item xs={12} md={6}>
                <Grid item xs={12}>
                  <Typography color='primary' variant='body1'>
                    {t('invoicing.invoiceVendorForm.country')}
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    disabled
                    variant='outlined'
                    margin='normal'
                    fullWidth
                    required
                    id='country'
                    name='country'
                    value={'Magyarország'}
                    onChange={handleChange}
                    error={Boolean(errors.country)}
                    helperText={touched.country && errors.country}
                  />
                </Grid>
              </Grid>{' '}
              <Grid container item xs={12} md={6}>
                <Grid item xs={12}>
                  <Typography color='primary' variant='body1'>
                    {t('invoicing.invoiceVendorForm.taxNumber')}
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    disabled={loading}
                    variant='outlined'
                    margin='normal'
                    fullWidth
                    required
                    id='vatNumber'
                    name='vatNumber'
                    value={values.vatNumber}
                    onChange={(e) => {
                      handleChange(e);
                      setVendorData({
                        ...vendorData,
                        vatNumber: e.target.value
                      });
                    }}
                    error={Boolean(errors.vatNumber)}
                    helperText={touched.vatNumber && errors.vatNumber}
                  />
                </Grid>
              </Grid>
              <Grid container item xs={12} md={6}>
                <Grid item xs={12}>
                  <Typography color='primary' variant='body1'>
                    {t('invoicing.invoiceVendorForm.vat')}
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    variant='outlined'
                    disabled={loading}
                    margin='normal'
                    fullWidth
                    required
                    select
                    id='vat'
                    name='vat'
                    value={values.vat}
                    onChange={(e) => {
                      handleChange(e);
                      setVendorData({
                        ...vendorData,
                        vat: e.target.value
                      });
                    }}
                    error={Boolean(errors.vat)}
                    helperText={touched.vat && errors.vat}>
                    <MenuItem value={'0'}>0%</MenuItem>
                    <MenuItem value={'27'}>27%</MenuItem>
                    <MenuItem value={'AAM'}>AAM</MenuItem>
                  </TextField>
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <Typography
                  style={{
                    fontWeight: 'bold',
                    fontSize: '1.2rem'
                  }}>
                  {t('invoicing.invoiceVendorForm.bank')}
                </Typography>
              </Grid>
              <Grid container item xs={12} md={6}>
                <Grid item xs={12}>
                  <Typography color='primary' variant='body1'>
                    {t('invoicing.invoiceVendorForm.bankName')}
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    disabled={loading}
                    variant='outlined'
                    margin='normal'
                    fullWidth
                    required
                    id='bankName'
                    name='bankName'
                    value={values.bankName}
                    onChange={(e) => {
                      handleChange(e);
                      setVendorData({
                        ...vendorData,
                        bankName: e.target.value
                      });
                    }}
                    error={Boolean(errors.bankName)}
                    helperText={touched.bankName && errors.bankName}
                  />
                </Grid>
              </Grid>
              <Grid container item xs={12} md={6}>
                <Grid item xs={12}>
                  <Typography color='primary' variant='body1'>
                    {t('invoicing.invoiceVendorForm.bankAccountNumber')}
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    disabled={loading}
                    variant='outlined'
                    margin='normal'
                    fullWidth
                    required
                    id='accountNumber'
                    name='accountNumber'
                    value={values.accountNumber}
                    onChange={(e) => {
                      handleChange(e);
                      setVendorData({
                        ...vendorData,
                        accountNumber: e.target.value
                      });
                    }}
                    error={Boolean(errors.accountNumber)}
                    helperText={touched.accountNumber && errors.accountNumber}
                  />
                </Grid>
              </Grid>
              <Grid container item xs={12} md={6}>
                <Grid item xs={12}>
                  <Tooltip
                    title={
                      'Nemzetközi bankszámlaszám, amely minden esetben az országod azonosító ISO kódjából és a számlaszámodból tevődik össze. Könnyen ellenőrizheted a netbankban, banki papírjaidon, vagy bankod ügyfélszolgálatánál'
                    }>
                    <Typography color='primary' variant='body1'>
                      {t('invoicing.invoiceVendorForm.iban')}
                      <InfoIcon
                        style={{
                          fontSize: '0.9rem',
                          opacity: '0.5',
                          marginLeft: '0.5rem'
                        }}
                      />
                    </Typography>
                  </Tooltip>
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    disabled={loading}
                    variant='outlined'
                    margin='normal'
                    fullWidth
                    required
                    id='iban'
                    name='iban'
                    value={values.iban}
                    onChange={(e) => {
                      handleChange(e);
                      setVendorData({
                        ...vendorData,
                        iban: e.target.value
                      });
                    }}
                    error={Boolean(errors.iban)}
                    helperText={touched.iban && errors.iban}
                  />
                </Grid>
              </Grid>
              <Grid container item xs={12}>
                <Grid container style={{ margin: '1rem 0' }}>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    style={{
                      display: 'flex',
                      justifyContent: 'center'
                    }}>
                    <Button
                      disabled={loading}
                      variant='contained'
                      color='primary'
                      onClick={setOpen}
                      className={styles.controlButton}>
                      {t('common.cancel')}
                    </Button>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    style={{
                      display: 'flex',
                      justifyContent: 'center'
                    }}>
                    <Button
                      disabled={loading}
                      variant='contained'
                      color='primary'
                      type='submit'
                      className={styles.controlButton}>
                      {loading ? (
                        <CircularProgress
                          size={24}
                          style={{
                            color: 'var(--primary-text-primary)'
                          }}
                        />
                      ) : (
                        t('common.save')
                      )}
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>
    </SettingsCard>
  );
};

export default InvoiceVendorForm;
